<template>
  <div class="template-connected">
    <div id="container">
      <div id="title">
        <h1 v-if="add && this.$route.params.choixForm == 1">
          Dépôt demande - Permission de voirie - Réseaux
        </h1>
        <h1 v-if="add && this.$route.params.choixForm == 2">
          Dépôt demande - Demande d'alignement
        </h1>
        <h1 v-if="add && this.$route.params.choixForm == 3">
          Dépôt demande - Permission de voirie - Accès/Clôture
        </h1>
        <h1 v-if="!add">Mise à jour demande</h1>
      </div>
      <div id="content" class="form-horizontal">
        <b-row>
          <b-col
            lg="12"
            md="12"
            sm="12"
            cols="12"
            :class="stepperClass"
            id="form"
          >
            <v-stepper ref="stepper" :steps="steps" v-model="stepControl">
              <template slot="step-1"> Localisation</template>
              <template slot="step-2"> Demande</template>
              <template slot="step-3"> Demandeur</template>
              <template slot="step-4"> Chantier</template>
              <template slot="step-5"> Pièces Jointes</template>
              <template slot="step-6"> Attestation</template>
            </v-stepper>
          </b-col>
        </b-row>
      </div>
      <div v-show="step === 1">
        <localisation
          v-if="render"
          :add="add"
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
        ></localisation>
      </div>
      <div v-show="step === 2">
        <info-demande
          :add="add"
          v-if="render"
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
        ></info-demande>
      </div>
      <div v-show="step === 3">
        <demandeur
          :add="add"
          v-if="render"
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
        ></demandeur>
      </div>
      <div v-show="step === 4">
        <choix-cerfa
          :add="add"
          v-if="render"
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
        ></choix-cerfa>
      </div>
      <div v-show="step === 5">
        <pieces
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
          v-model="pieces"
          v-if="render"
        ></pieces>
      </div>
      <div v-show="step === 6">
        <attestation
          :add="add"
          :is-processing="isProcessing"
          v-if="render"
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
        >
        </attestation>
      </div>
    </div>
  </div>
</template>

<script>
import { VStepper } from "vue-stepper-component";
import Vuex from "vuex";

import router from "../router/index.js";
import Localisation from "../views/Cerfas/Localisation.vue";
import Demandeur from "../views/Cerfas/Demandeur.vue";
import ChoixCerfa from "../views/Cerfas/ChoixCerfa.vue";
import Attestation from "./Cerfas/Attestation.vue";
import PiecesJointes from "./Cerfas/PiecesJointes.vue";
import InfoDemande from "../views/Cerfas/InfoDemande.vue";
import Vue from "vue";

export default {
  name: "AjoutDossier",

  async mounted() {
    if (this.$route.params.id) {
      this.add = false;
      await this.getDossier(this.$route.params.id);

      if (this.$route.name == "updatedossier" && this.request.stateId != 8) {
        alert("Votre demande n'est pas en état de complétude");
        router.push({ name: "Dossiers" });
      }

      this.setStep(1);
      await this.setPetitioner(this.request.petitioner);

      if (this.request.beneficiary != null) {
        await this.setBeneficiary(this.request.beneficiary);
        this.request.isbeneficiaire = true;
      }

      if (this.request.cerfa1402301 != null) {
        if (this.request.cerfa1402301.isAccessDevelopment == true) {
          this.request.type = 3;
        } else {
          this.request.type = 1;
        }
      }
      if (this.request.individualAlignmentRequest != null) {
        this.request.type = 2;
      }

      await this.setAlignement(this.request.individualAlignmentRequest);

      await this.setCerfa14023(this.request.cerfa1402301);
      this.render = true;
    } else {
      this.setStep(1);
      this.$nextTick(async () => {
        this.add = true;
        await this.initDossier();
        this.request.type = this.$route.params.choixForm;

        await this.initPoint();
        await this.initPetitioner(false);
        await this.initPetitioner(true);
        await this.initCerfa14023();
        await this.initAlignement();

        this.render = true;
      });
    }
  },

  beforeDestroy() {
    //vidage du niveau de dessin et de point
    window.Event.$emit("clearLayer", "RequestPointLayer");
    window.Event.$emit("clearLayer", "drawnFeatures");
  },
  data: () => ({
    add: true,
    stepperClass: "no-padding form-horizontal",
    render: false,
    pieces: {
      isValid: true,
      cerfa14023: {
        pieceComplementaire: null,
        planSituation: null,
        planLocalisation: null,
        photos: null,
        nature: {
          clotureStationnement: {
            coupesLongitudinales: null,
          },
          amenagement: {
            planOuvrage: null,
            coupesTechniques: null,
            planFranchissement: null,
          },
          stationService: {
            planImplantation: null,
          },
        },
      },
      types: {
        cerfa14023: {
          pieceComplementaire: 18,
          planSituation: 1,
          planLocalisation: 3,
          photos: 5,
          coupesLongitudinales: 6,
          planOuvrage: 8,
          coupesTechniques: 9,
          planFranchissement: 10,
          planImplantation: 11,
        },
      },
    },
    pages: ["demandeurInfo", "request", "cerfa", "pieces", "attestation"],
    isProcessing: false,
  }),
  components: {
    localisation: Localisation,
    demandeur: Demandeur,
    "info-demande": InfoDemande,
    "choix-cerfa": ChoixCerfa,
    attestation: Attestation,
    pieces: PiecesJointes,
    VStepper,
  },
  watch: {
    step: {
      deep: true,
      handler: function(val, oldVal) {
        if (val === 1) {
          //TODO: degeu à changer
          setTimeout(function() {
            window.Event.$emit("refreshMap");
          }, 2);
        }
      },
    },
  },
  computed: {
    request: {
      get: function() {
        return this.dossierSelected;
      },
      set: function(newValue) {
        this.setDossier(newValue);
      },
    },
    ...Vuex.mapGetters("StepperDemande", ["steps", "step", "stepsMap"]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
    ...Vuex.mapGetters("Dossiers", ["dossierSelected"]),
    ...Vuex.mapGetters("Petitioner", ["petitioner", "beneficiary"]),
    ...Vuex.mapGetters("Cerfa", ["cerfa14023", "alignement"]),
    ...Vuex.mapGetters("Document", ["missingDocuments"]),
    stepControl: {
      get() {
        return this.step;
      },
      set(step) {
        this.setStep(step);
      },
    },
  },

  methods: {
    error(message) {
      this.stepperClass = "errorstepper no-padding form-horizontal";
      Vue.prototype.$awn.alert(message);
    },

    ...Vuex.mapActions("StepperDemande", ["setStep"]),
    ...Vuex.mapActions("Dossiers", [
      "addDossier",
      "initDossier",
      "initPoint",
      "getDossier",
      "updateDossier",
      "sendToClicmap",
      "deleteDossier",
    ]),
    ...Vuex.mapActions("Petitioner", [
      "addPetitionner",
      "updatePetitionner",
      "initPetitioner",
      "setPetitioner",
      "setBeneficiary",
    ]),
    ...Vuex.mapActions("Cerfa", [
      "addCerfa14023",
      "initCerfa14023",
      "setAlignement",
      "addAlignement",
      "updateAlignement",
      "initAlignement",
      "setCerfa14023",
      "updateCerfa14023",
    ]),
    ...Vuex.mapActions("Document", ["sendDocument", "getDocuments"]),
    previousStep(stepper) {
      if (stepper.index == 2 && this.request.type == 2) {
        this.setStep(1);
        this.stepperClass = "no-padding form-horizontal";
        document.getElementById("container").scrollTo(0, 0);
      } else {
        this.stepperClass = "no-padding form-horizontal";
        stepper.previous();
        document.getElementById("container").scrollTo(0, 0);
      }
    },
    nextStep(stepper) {
      if (this.steps === this.stepControl) {
        this.Finish();
      } else {
        //Si alignement faire en sorte de passer info-demande (dates) !
        if (stepper.index == 0 && this.request.type == 2) {
          this.setStep(3);
          this.stepperClass = "no-padding form-horizontal";
          document.getElementById("container").scrollTo(0, 0);
        } else {
          stepper.next();
          this.stepperClass = "no-padding form-horizontal";
          document.getElementById("container").scrollTo(0, 0);
        }
      }
    },
    async sendDocuments(request_id, std_user_id) {
      for (const [key, value] of Object.entries(this.missingDocuments)) {
        if (!!value.file) {
          value.file.typeDocumentId = value.typeDocument.id;
          value.file.stdUserId = std_user_id;
          value.file.requestId = request_id;
          await this.sendDocument(value.file);
        }
      }
    },
    async Finish(stepper) {
      if (this.isProcessing) return;
      this.isProcessing = true;

      if (this.add == true) {
        try {
          // Ajout du pétitionnaire
          this.request.petitionerId = await this.addPetitionner(this.petitioner);
          if (!this.request.petitionerId) {
            throw new Error("Erreur lors de l'ajout du demandeur.");
          }

          // Ajout du bénéficiaire, si applicable
          if (this.request.isbeneficiaire) {
            this.request.beneficiaryId = await this.addPetitionner(this.beneficiary);
            if (!this.request.beneficiaryId) {
              throw new Error("Erreur lors de l'ajout du bénéficiaire.");
            }
          }

          // Gestion des différents types de demande
          const type = Number(this.request.type);

          if (type === 1 || type === 3) {
            this.cerfa14023.isAccessDevelopment = type === 3;

            this.request.cerfa1402301Id = await this.addCerfa14023(this.cerfa14023);
            if (!this.request.cerfa1402301Id) {
              throw new Error("Erreur lors de la création du Cerfa 14023.");
            }
          }

          if (type === 2) {
            this.request.alignementId = await this.addAlignement(this.alignement);
            if (!this.request.alignementId) {
              throw new Error("Erreur lors de la création de l'alignement.");
            }
          }

          // Tentative d'ajout d'un dossier
          this.request.id = await this.addDossier(this.request);
          
          // Vérification de l'ID du dossier
          if (!this.request.id) {
            throw new Error("Erreur lors de la création du dossier.");
          }

          this.request.stateId = 3;
          await this.updateDossier(this.request);

          // Optionnel: transmission à Clicmap
          // await this.sendToClicmap(this.request.id);

          try {
            // Envoi des documents requis
            await this.sendDocuments(this.request.id, this.userConnected.id);
          } catch (error) {
            console.error("Erreur lors de l'upload des fichiers", error);
            Vue.prototype.$awn.warning("Dossier déposé, mais certains fichiers n'ont pu être envoyés. Une complétude sera nécessaire.");
          }

          // Vidage du niveau de dessin et de point
          window.Event.$emit("clearLayer", "RequestPointLayer");
          window.Event.$emit("clearLayer", "drawnFeatures");

          let encrypted = this.$aes.encrypt(this.request.id.toString());
          router.push({ name: "Dossier", params: { id: encrypted } });
        } catch (error) {
          console.error("Une erreur est survenue lors de l'ajout :", error);
          Vue.prototype.$awn.alert("Erreur lors de l'ajout du dossier : " + error.message);
          this.isProcessing = false;

          if (this.request.id) {
            try {
              await this.deleteDossier(this.request.id);
            } catch (deleteError) {
              console.error("Erreur lors de la suppression du dossier :", deleteError);
            }
          }
        }
      } else {
        // Partie pour la mise à jour d'un dossier existant
        await this.updatePetitionner(this.petitioner);
        if (this.petitioner.isbeneficiaire) {
          await this.updatePetitionner(this.beneficiary);
        }

        const type = Number(this.request.type);

        if (type === 1 || type === 3) {
          this.cerfa14023.instructeurId = this.userConnected.id;
          await this.updateCerfa14023(this.cerfa14023);
        } else if (type === 2) {
          this.request.instructeurId = this.userConnected.id;
          await this.updateAlignement(
            this.alignement || this.request.individualAlignmentRequest
          );
        }

        // Gestion des documents manquants et de l'état de la demande
        if (this.request.stateId === 8) {
          this.request.missingDocuments = this.missingDocuments;
          await this.sendDocuments(this.request.id, this.userConnected.id);
          this.request.stateId = 9;
          this.request.missingDocuments = null;
        } else {
          await this.sendDocuments(this.request.id, this.userConnected.id);
        }

        await this.updateDossier(this.request);
        
        let encrypted = this.$aes.encrypt(this.request.id.toString());
        router.push({ name: "Dossier", params: { id: encrypted } });
      }
    }
  },
};
</script>

<style scoped>
/* prevent click events on all steppers */
div.v-stepper {
  pointer-events: none;
}
</style>
